export type AdminRole = 'Super' | 'Global' | 'Regional';
export type AdminFunctionalRole = 'Regional Consultant' | 'Paralegal' | 'Media Manager';
export type Region = 'North America' | 'South America' | 'Oceania' | 'Africa' | 'Middle East' | 'Europe' | 'Asia';
export type OrganizationRegion = Region | 'Global';

export const REGION_OPTIONS: Region[] = ['North America', 'South America', 'Oceania', 'Africa', 'Middle East', 'Europe', 'Asia'];
export const ADMIN_FUNCTIONAL_ROLES: AdminFunctionalRole[] = ['Regional Consultant', 'Paralegal', 'Media Manager'];

interface AdminAssignments {
    adminRole?: string | null;
    adminRoles?: unknown;
    regions?: unknown;
    status?: string;
    isDeleted?: boolean;
    isTestConsultant?: boolean;
}

export function adminRolesFor(profile: AdminAssignments): AdminFunctionalRole[] {
    if (profile.adminRoles === undefined)
        return profile.adminRole === 'Regional' ? ['Regional Consultant'] : [];
    const assignedRoles = profile.adminRoles;
    return Array.isArray(assignedRoles) ? ADMIN_FUNCTIONAL_ROLES.filter(role => assignedRoles.includes(role)) : [];
}

export function hasRegionalConsultantRole(profile: AdminAssignments): boolean {
    return ['Super', 'Global', 'Regional'].includes(String(profile.adminRole)) && adminRolesFor(profile).includes('Regional Consultant');
}

export function isActiveRegionalConsultant(profile: AdminAssignments): boolean {
    return profile.status === 'active' && profile.isDeleted !== true && hasRegionalConsultantRole(profile);
}

export function adminAssignmentError(adminRoles: unknown, regions: unknown): string | null {
    if (!Array.isArray(adminRoles) || adminRoles.some(role => !ADMIN_FUNCTIONAL_ROLES.includes(role)))
        return 'Select valid administrator roles.';
    if (!Array.isArray(regions) || regions.some(region => !REGION_OPTIONS.includes(region)))
        return 'Select valid served regions.';
    return adminRoles.includes('Regional Consultant') && !regions.length ? 'Regional Consultants require at least one served region.' : null;
}

export function adminRoleLabel(role: AdminRole | null | undefined): string {
    return role === 'Regional' ? 'Regional Admin' : role === 'Global' ? 'Global Admin' : 'Super Admin';
}
